export default __webpack_public_path__ + "static/media/portfolio-148.9087a034.jpg";